const RowExpansionColumn = ({
  label,
  value,
  containerClassName,
  spanClassName,
  visible = true,
}: ColumnProps) => {
  if (!visible) return;

  return (
    <div className={`col-3 p-1 ${containerClassName}`}>
      <span className={`bold mr-2 ${spanClassName}`}>{label}</span>
      <span>{value}</span>
    </div>
  );
};

type ColumnProps = {
  label: string;
  value: string;
  containerClassName?: string;
  spanClassName?: string;
  visible?: boolean;
};

export default RowExpansionColumn;
